import { Link } from "react-router-dom";
import { imgUrl, fmtDate, pickLang } from "@/lib/api";
import { TrendBadge } from "./TrendBadge";

const pick = (s, lang) => s[pickLang(s, lang)] || {};

export const StoryCard = ({ story, lang, variant = "default" }) => {
  const v = pick(story, lang);
  const cat = story.category ? (lang === "ta" ? story.category.name_ta : story.category.name_en) : "";
  const big = variant === "lead";
  const compact = variant === "compact";
  return (
    <Link
      to={`/story/${story.slug}`}
      data-testid={`story-card-${story.slug}`}
      className={`group block ${pickLang(story, lang) === "ta" ? "lang-ta" : ""}`}
    >
      {!compact && (
        <div className={`overflow-hidden bg-zinc-200 ${big ? "aspect-[16/9]" : "aspect-[3/2]"} mb-4`}>
          {story.cover_image ? (
            <img
              src={imgUrl(story.cover_image)}
              alt=""
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
            />
          ) : (
            <div className="h-full w-full flex items-end p-4 bg-zinc-900 text-zinc-500 font-serif-head text-2xl">
              {cat}
            </div>
          )}
        </div>
      )}
      <div className="flex items-center gap-2 mb-2">
        <TrendBadge trend={story.trend_type} lang={lang} testId={`card-badge-${story.slug}`} />
        {cat && <span className="text-[11px] font-semibold uppercase tracking-[0.12em] text-zinc-500">{cat}</span>}
      </div>
      <h3
        className={`font-serif-head font-bold text-zinc-900 leading-snug decoration-2 underline-offset-4 group-hover:underline ${
          big ? "text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight" : compact ? "text-base sm:text-lg" : "text-xl sm:text-2xl"
        }`}
      >
        {v.headline}
      </h3>
      {!compact && v.summary && (
        <p className={`mt-2 text-zinc-600 leading-relaxed ${big ? "text-base sm:text-lg" : "text-sm"} line-clamp-3`}>{v.summary}</p>
      )}
      <p className="mt-3 text-[11px] uppercase tracking-[0.08em] text-zinc-500 font-mono-meta">
        {fmtDate(story.published_at, lang)}
      </p>
    </Link>
  );
};
